/**
 * The creators a profile follows on Social when it has not chosen its own
 * (owner, 2026-10-07: individual influencers and podcasters, mixed across
 * podcasts, sports, music, fashion and movies/TV — not the big companies).
 *
 * Channel ids are YouTube's own (UC…), read from each creator's public channel
 * page on 2026-10-07; a handle can change, an id never does.
 */

export type CreatorCategory = "podcasts" | "sports" | "music" | "fashion" | "movies";

export interface Creator {
  channelId: string;
  name: string;
  category: CreatorCategory;
}

/** Rows in this order, under these names. */
export const CREATOR_CATEGORIES: Array<{ id: CreatorCategory; title: string }> = [
  { id: "podcasts", title: "Podcasts" },
  { id: "sports", title: "Sports" },
  { id: "music", title: "Music" },
  { id: "fashion", title: "Fashion & Beauty" },
  { id: "movies", title: "Movies & TV" },
];

export const DEFAULT_CREATORS: Creator[] = [
  { channelId: "UC23_r1bpkTWaBltbXsQxysA", name: "Joe Budden", category: "podcasts" },
  { channelId: "UCzQUP1qoWDoEbmsQxvdjxgQ", name: "Joe Rogan", category: "podcasts" },
  { channelId: "UC5AQEUAwCh1sGDvkQtkDWUQ", name: "Theo Von", category: "podcasts" },
  { channelId: "UCyGi3eCuxko37WB6uUr7LjA", name: "Call Her Daddy", category: "podcasts" },
  { channelId: "UCGq-a57w-aPwyi3pW7XLiHw", name: "The Diary Of A CEO", category: "podcasts" },
  { channelId: "UCvYrhzKs1c8LajTP687ifEA", name: "Flagrant", category: "podcasts" },

  { channelId: "UCxcTeAKWJca6XyJ37_ZoKIQ", name: "The Pat McAfee Show", category: "sports" },
  { channelId: "UCWsDFcIhY2DBi3GB5uykGXA", name: "IShowSpeed", category: "sports" },
  { channelId: "UCH_X8MFx0LSBbA7JsQm5xXw", name: "Stephen A. Smith", category: "sports" },
  { channelId: "UCAvjYgmwadC682OoC4Cc6TQ", name: "Gil's Arena", category: "sports" },
  { channelId: "UCyKV3Zl7AKVj7ikyOlcfZTQ", name: "Cam Newton", category: "sports" },
  { channelId: "UC4mLlRa_dezwvytudo9s1sw", name: "Deestroying", category: "sports" },

  { channelId: "UCHj-cA0ChFLGTxAS4ZIdnVw", name: "DJ Akademiks", category: "music" },
  { channelId: "UCJquYOG5EL82sKTfH9aMA9Q", name: "Rick Beato", category: "music" },
  { channelId: "UCApPPpJ4d3ueW38lArwiWoA", name: "Kenny Beats", category: "music" },
  { channelId: "UCt7fwAhXDy3oNFTAzF2o8Pw", name: "Anthony Fantano", category: "music" },
  { channelId: "UCwppdrjsBPAZg5_cUwQjfMQ", name: "Charlie Puth", category: "music" },
  { channelId: "UCtmY49Zn4l0RMJnTWfV7Wsg", name: "Jacob Collier", category: "music" },

  { channelId: "UC3EFKdXAU99j3ppGgvTz7XQ", name: "Bretman Rock", category: "fashion" },
  { channelId: "UC78cxCAcp7JfQPgKxYdyGrg", name: "Emma Chamberlain", category: "fashion" },
  { channelId: "UCzTKskwIc_-a0cGvCXA848Q", name: "NikkieTutorials", category: "fashion" },
  { channelId: "UCzJIliq68IHSn-Kwgjeg2AQ", name: "Jackie Aina", category: "fashion" },
  { channelId: "UCucot-Zp428OwkyRm2I7v2Q", name: "James Charles", category: "fashion" },
  { channelId: "UCkMUkHfV7SyEimqZOWVhtWg", name: "Mikayla Nogueira", category: "fashion" },

  { channelId: "UCq6VFHwMzcMXbuKyG7SQYIg", name: "penguinz0", category: "movies" },
  { channelId: "UCAXR2zenCwvRIyQd9ydtfaA", name: "Grace Randolph", category: "movies" },
  { channelId: "UCCqEeDAUf4Mg0GgEN658tkA", name: "Chris Stuckmann", category: "movies" },
  { channelId: "UCSJPFQdZwrOutnmSFYtbstA", name: "The Critical Drinker", category: "movies" },
  { channelId: "UC7v3-2K1N84V67IF-WTRG-Q", name: "Jeremy Jahns", category: "movies" },
  { channelId: "UCDiFRMQWpcp8_KD4vwIVicw", name: "Emergency Awesome", category: "movies" },
];
